'use client';

import React from 'react';
import { intlFormat, parseISO } from 'date-fns';
import styled from 'styled-components';
import { useTranslation } from '@/app/components/translations/Translation';

import { usePageWrapperData } from '@/app/common/pageWrapperProvider.tsx';

export function LmnDealMessage(props: { bookDate: string; checkin: string | undefined; checkout: string | undefined }) {
  const { bookDate, checkin, checkout } = props;
  const { translateWithElements } = useTranslation();
  const { localization } = usePageWrapperData();
  const message = translateWithElements('vacation.select.flashsales.banner.description', {
    bookDate: (
      <b
        css={`
          white-space: nowrap;
        `}
        key="1"
      >
        {intlFormat(
          parseISO(bookDate),
          {
            month: 'long',
            day: 'numeric',
            year: 'numeric',
          },
          {
            locale: localization.locale,
          }
        )}
      </b>
    ),
    checkin: (
      <b
        css={`
          white-space: nowrap;
        `}
        key="2"
      >
        {checkin ? (
          intlFormat(
            parseISO(checkin),
            {
              month: 'long',
              day: 'numeric',
            },
            {
              locale: localization.locale,
            }
          )
        ) : (
          <TransparentPlaceholder>___________</TransparentPlaceholder>
        )}
      </b>
    ),
    checkout: (
      <b
        css={`
          white-space: nowrap;
        `}
        key="3"
      >
        {checkout ? (
          intlFormat(
            parseISO(checkout),
            {
              month: 'long',
              day: 'numeric',
              year: 'numeric',
            },
            {
              locale: localization.locale,
            }
          )
        ) : (
          <TransparentPlaceholder>___________</TransparentPlaceholder>
        )}
      </b>
    ),
  });
  return message;
}

const TransparentPlaceholder = styled.span`
  background-color: white;
  opacity: 0.15;
`;
